import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { color, Typography, Button, FlexBox } from '@kis-technologies/kis-ui';
import { selectors as mediaSelectors } from 'store/media';
import { ControlsProps, MediaTypes } from '../types';
import { getMediaTypeLabel } from '../utils';

const Controls = (props: ControlsProps) => {
  const {
    configuration,
    mediaCount,
    mediaType,
    onAddClick = () => {},
    onMakeActiveClick = () => {},
    onSetTimeClick = () => {}
  } = props;

  const { pending } = useSelector(mediaSelectors.selectAction);

  const attractLoopType = get(configuration, 'configuration.globalSettings.attractLoop.type');

  const mediaLabel = getMediaTypeLabel(mediaType);
  const showActiveButton =
    (mediaType === MediaTypes.ATTRACT_IMAGE && mediaCount > 0) ||
    (mediaType === MediaTypes.ATTRACT_VIDEO && mediaCount > 0) ||
    (mediaType === MediaTypes.LINKED_CONTENT && mediaCount > 0);
  const showSlideTimeButton = mediaType === MediaTypes.ATTRACT_IMAGE && mediaCount > 1;
  const showAddButton =
    (mediaType === MediaTypes.ATTRACT_IMAGE && mediaCount < 10) ||
    (mediaType === MediaTypes.ATTRACT_VIDEO && mediaCount < 1) ||
    (mediaType === MediaTypes.LINKED_CONTENT && mediaCount < 1) ||
    (mediaType === MediaTypes.LOGO_IMAGE_LARGE && mediaCount < 1) ||
    (mediaType === MediaTypes.LOGO_IMAGE && mediaCount < 1) ||
    (mediaType === MediaTypes.INACTIVE_IMAGE && mediaCount < 1) ||
    (mediaType === MediaTypes.SPLASH_IMAGE && mediaCount < 1) ||
    (mediaType === MediaTypes.BACKGROUND_IMAGE && mediaCount < 1);

  return (
    <FlexBox fullWidth align="center" margin="0 0 5 0" justify="between">
      <FlexBox gap={3} align="center">
        {/* ACTIVE BUTTON/STATUS */}
        {showActiveButton && (
          <>
            {attractLoopType === mediaType ? (
              <Typography fontSize={18} fontWeight={600} color={color.PRIMARY}>
                Active
              </Typography>
            ) : (
              <Button customSize="small" onClick={onMakeActiveClick} isLoading={pending} width={175}>
                Make Active
              </Button>
            )}
          </>
        )}
        {/* SET (SLIDE) TIME BUTTON */}
        {showSlideTimeButton && (
          <Button customSize="small" onClick={onSetTimeClick} isLoading={pending} width={175}>
            {`Set ${mediaLabel} Time`}
          </Button>
        )}
      </FlexBox>
      {/* ADD BUTTON */}
      {showAddButton && (
        <Button customSize="small" onClick={onAddClick} isLoading={pending} width={187}>
          {mediaLabel === 'Slide' ? `Create ${mediaLabel}` : `Select ${mediaLabel}`}
        </Button>
      )}
    </FlexBox>
  );
};

export default Controls;
